<template>
    <div class="content-box">
        <Title/>

        <div v-if="loading" class="loading-container">
            <div class="loading-skeleton">
                <div v-for="i in skeletonCount" :key="i" class="skeleton-item"></div>
            </div>
            <div class="loading-text">加载中...</div>
        </div>

        <div v-else-if="error" class="error-container">
            <div class="error-icon">!</div>
            <div class="error-message">{{ error }}</div>
            <button class="retry-btn" @click="fetchData">重新加载</button>
        </div>

        <div v-else-if="normalizedItems.length === 0" class="empty-container">
            <div class="empty-icon">-</div>
            <div class="empty-message">暂无视频内容</div>
        </div>

        <div v-else>
            <div class="video-grid">
                <div
                v-for="(item, index) in displayedItems"
                :key="index"
                class="video-card"
                :class="{ 'video-card-loading': !item.loaded }"
                @click="navigateTo(item.link)"
                tabindex="0"
                @keydown.enter="navigateTo(item.link)"
                >
                    <div class="video-thumbnail">
                        <img
                        :src="item.loaded ? item.thumbnail : placeholderImage"
                        :data-src="item.thumbnail"
                        :alt="item.title"
                        class="thumbnail-img"
                        :class="{ 'lazy-load': !item.loaded }"
                        @error="handleImageError(item)"
                        @load="handleImageLoad(item)"
                        />
                        <div v-if="item.hasPlayIcon !== false" class="play-overlay">
                            <span class="play-icon">▶</span>
                        </div>
                    </div>
                    <div class="video-info">
                        <div class="video-title">{{ item.title }}</div>
                        <div v-if="item.date" class="video-date">{{ item.date }}</div>
                    </div>
                </div>
            </div>

            <div v-if="hasMore && !loadingNext" class="pagination-container">
                <button
                class="next-page-btn"
                @click="loadNextPage"
                @keydown.enter="loadNextPage"
                tabindex="0"
                aria-label="加载下一页视频"
                >
                    <span class="btn-text">下一页</span>
                    <span class="btn-icon">→</span>
                </button>
            </div>

            <div v-if="loadingNext" class="pagination-loading">
                <span class="loading-spinner"></span>
                <span class="loading-text">加载中...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "shortvideo",
    props: {
        dataMode: {
            type: String,
            default: 'local',
            validator: (value) => ['api', 'local'].includes(value)
        },
        localData: {
            type: Array,
            default: () => [
               
                {
                    thumbnail: '/Public/Upload/image/20260724/1784886917767453.png',
                    // title: '短视频2',
                    link: 'https://weixin.qq.com/sph/AfdFTLXLpz',
                    // date: '2026-07-24'
                },
                {
                    thumbnail: '/Public/Upload/image/20260724/1784886989988851.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AqnXF9UzXk',
                    // date: '2026-07-24'
                },
                {
                    thumbnail: '/Public/Upload/image/20260728/1785220549467982.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AjyYffKzdy',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785220658140113.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AyEQul0AkP',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785220702392482.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/A7Sg7iFzj0',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785220764553354.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AnLSz69I3p',
                    // date: '2026-07-24'
                },{
                    thumbnail: '/Public/Upload/image/20260728/1785220915481724.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/Aekdr3o0vi',
                    // date: '2026-07-24'
                },
                {
                    thumbnail: '/Public/Upload/image/20260728/1785220944165698.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AQgsZgDnTh',
                    // date: '2026-07-24'
                },
                {
                    thumbnail: '/Public/Upload/image/20260728/1785221272349542.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/Akd9xfWpxj',
                    // date: '2026-07-24'
                },
                {
                    thumbnail: '/Public/Upload/image/20260728/1785221466534567.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AQH9FN0vJP',
                    // date: '2026-07-24'
                },
                {
                    thumbnail: '/Public/Upload/image/20260728/1785221701318206.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AJJMlQrY4x',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785221747457202.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AeJVW7U1NC',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785221810957998.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/A3RSNY7UPp',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785221869798432.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/AmJObivW2j',
                    // date: '2026-07-24'
                },
                 {
                    thumbnail: '/Public/Upload/image/20260728/1785221907169172.png',
                    // title: '短视频3',
                    link: 'https://weixin.qq.com/sph/Ao7KmLLtzW',
                    // date: '2026-07-24'
                },

               
            ]
        },
        apiKeys: {
            type: String,
            default: '短视频 车'
        }
    },
    data() {
        return {
            loading: false,
            loadingNext: false,
            error: null,
            apiItems: [],
            currentPage: 1,
            itemsPerPageDesktop: 30,
            itemsPerPageMobile: 10,
            params: {
                json: 0,
                filter: ["研报", "分析", "（PPT）", "（全文）"],
            },
            placeholderImage: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="200" viewBox="0 0 300 200"%3E%3Crect fill="%23f5f5f5" width="300" height="200"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="14" x="50%25" y="50%25" text-anchor="middle" dominant-baseline="middle"%3E视频封面%3C/text%3E%3C/svg%3E',
                isMobile: false,
                intersectionObserver: null
        }
    },
    computed: {
        normalizedItems() {
            if (this.dataMode === 'local') {
                return this.localData.map(item => ({
                    thumbnail: item.thumbnail || this.placeholderImage,
                    title: item.title || '未命名视频',
                    link: item.link || '#',
                    date: item.date || '',
                    hasPlayIcon: item.hasPlayIcon !== undefined ? item.hasPlayIcon : true,
                    loaded: false
                }))
            }
            return this.apiItems.map(item => ({
                thumbnail: item.image || item.thumbnail || this.placeholderImage,
                title: item.title || item.text || '未命名视频',
                link: item.url || item.link || '#',
                date: item.date || '',
                hasPlayIcon: true,
                loaded: false
            }))
        },
        itemsPerPage() {
            return this.isMobile ? this.itemsPerPageMobile : this.itemsPerPageDesktop
        },
        displayedItems() {
            const end = this.currentPage * this.itemsPerPage
            return this.normalizedItems.slice(0, end)
        },
        hasMore() {
            return this.displayedItems.length < this.normalizedItems.length
        },
        skeletonCount() {
            return this.isMobile ? 4 : 6
        }
    },
    watch: {
        '$store.state.text': function(newText) {
            if (this.dataMode === 'api' && newText && newText.length > 0) {
                this.apiItems = newText
                this.loading = false
                this.error = null
            }
        }
    },
    created() {
        this.checkDeviceType()
        if (this.dataMode === 'api') {
            this.fetchData()
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
        this.initLazyLoad()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect()
        }
    },
    methods: {
        checkDeviceType() {
            this.isMobile = window.innerWidth <= 768
        },
        handleResize() {
            const wasMobile = this.isMobile
            this.isMobile = window.innerWidth <= 768
            if (wasMobile !== this.isMobile) {
                this.currentPage = 1
            }
        },
        initLazyLoad() {
            if ('IntersectionObserver' in window) {
                this.intersectionObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const img = entry.target
                            const src = img.dataset.src
                            if (src) {
                                img.src = src
                                img.classList.remove('lazy-load')
                            }
                            this.intersectionObserver.unobserve(img)
                        }
                    })
                }, {
                    rootMargin: '100px',
                    threshold: 0.1
                })

                this.$nextTick(() => {
                    const lazyImages = document.querySelectorAll('.lazy-load')
                    lazyImages.forEach(img => {
                        this.intersectionObserver.observe(img)
                    })
                })
            } else {
                this.$nextTick(() => {
                    const lazyImages = document.querySelectorAll('.lazy-load')
                    lazyImages.forEach(img => {
                        const src = img.dataset.src
                        if (src) {
                            img.src = src
                            img.classList.remove('lazy-load')
                        }
                    })
                })
            }
        },
        fetchData() {
            this.loading = true
            this.error = null
            this.apiItems = []
            this.currentPage = 1
            try {
                this.$store.commit('textparams', this.params)
                this.$store.commit('changeKeys', this.apiKeys)
                this.$store.dispatch('getText').catch(err => {
                    this.loading = false
                    this.error = '数据加载失败，请稍后重试'
                })
            } catch (err) {
                this.loading = false
                this.error = '数据请求异常'
            }
        },
        loadNextPage() {
            if (this.loadingNext || !this.hasMore) return
            this.loadingNext = true
            setTimeout(() => {
                this.currentPage++
                this.loadingNext = false
                this.$nextTick(() => {
                    this.initLazyLoad()
                })
            }, 300)
        },
        navigateTo(link) {
            if (link && link !== '#') {
                window.open(link, '_blank')
            }
        },
        handleImageError(item) {
            if (item && item.thumbnail) {
                item.thumbnail = this.placeholderImage
                item.loaded = true
            }
        },
        handleImageLoad(item) {
            item.loaded = true
        }
    }
}
</script>

<style scoped>
.video-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px 0;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 1200px) {
    .video-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 992px) {
    .video-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .video-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }
}

@media (max-width: 576px) {
    .video-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
}

.video-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    opacity: 0;
    animation: cardFadeIn 0.3s ease-out forwards;
}

.video-card:nth-child(3n+1) { animation-delay: 0.05s; }
.video-card:nth-child(3n+2) { animation-delay: 0.1s; }
.video-card:nth-child(3n+3) { animation-delay: 0.15s; }

@keyframes cardFadeIn {
    from {
        opacity: 0;
        transform: translateY(15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.video-card:focus {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
}

.video-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.video-card-loading {
    opacity: 0.6;
}

.video-thumbnail {
    position: relative;
    width: 100%;
    padding-top: 155.25%;
    background: #f5f5f5;
    overflow: hidden;
}

.thumbnail-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
}

.thumbnail-img.lazy-load {
    opacity: 0;
}

.play-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
}

.video-card:hover .play-overlay {
    background: rgba(0, 0, 0, 0.8);
}

.play-icon {
    color: #fff;
    font-size: 20px;
    margin-left: 4px;
}

.video-info {
    padding: 12px;
}

.video-title {
    font-size: 14px;
    color: #333;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 6px;
}

.video-date {
    font-size: 12px;
    color: #999;
}

.loading-container {
    padding: 40px 0;
    text-align: center;
}

.loading-skeleton {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 20px;
}

@media (max-width: 1200px) {
    .loading-skeleton {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .loading-skeleton {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }
}

.skeleton-item {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 8px;
    height: 220px;
}

@keyframes loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.loading-text {
    color: #999;
    font-size: 14px;
}

.error-container {
    padding: 60px 0;
    text-align: center;
}

.error-icon {
    width: 60px;
    height: 60px;
    background: #ff4d4f;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    margin: 0 auto 16px;
}

.error-message {
    color: #666;
    font-size: 14px;
    margin-bottom: 16px;
}

.retry-btn {
    padding: 8px 24px;
    background: #1890ff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.3s ease;
}

.retry-btn:hover {
    background: #40a9ff;
}

.empty-container {
    padding: 60px 0;
    text-align: center;
}

.empty-icon {
    width: 60px;
    height: 60px;
    background: #f5f5f5;
    color: #ccc;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    margin: 0 auto 16px;
}

.empty-message {
    color: #999;
    font-size: 14px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    padding: 30px 0;
}

.next-page-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 30px;
    background: #fff;
    color: #333;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
}

.next-page-btn:hover {
    background: #f5f5f5;
    border-color: #1890ff;
    color: #1890ff;
}

.next-page-btn:focus {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
}

.next-page-btn:active {
    transform: scale(0.98);
}

.btn-text {
    font-weight: 500;
}

.btn-icon {
    font-size: 16px;
}

.pagination-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 30px 0;
}

.loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #f0f0f0;
    border-top-color: #1890ff;
    border-radius: 50%;
    animation: spinner 0.6s linear infinite;
}

@keyframes spinner {
    to {
        transform: rotate(360deg);
    }
}

.pagination-loading .loading-text {
    margin: 0;
}
</style>